import React from 'react';
import {connect} from 'react-redux';
import IngredientGroup from './IngredientGroup';
import * as s from './../selectors';
import * as a from './../actions';
import {formatMoney} from "../functions";

function ConfiguratorPanel({ingredientGroups, modes, selectMode, texts, totalPrice, formatMoney, finish})  {

    const configurationModes = modes.length > 1 ? (
        <div className="configurator-panel__modes">
            {config.modes.map((mode) => {
                return <button
                    className={`configurator-panel__mode ${mode.selected ? "configurator-panel__mode--selected" : ''}`}
                    onClick={selectMode(mode)}
                >{mode.label}</button>;
            })}
        </div>
    ) : '';

    return (
        <div className="configurator-panel">
            {configurationModes}
            {ingredientGroups.map((group) => {
                return <IngredientGroup key={group.id} group={group}/>
            })}
            <button onClick={finish} className="configurator-panel__finish-button btn btn--primary w-100 mt-10">
                {`${texts.finishButton} \/ ${formatMoney(totalPrice)}`}
            </button>
        </div>
    );
}

export default connect(
    (state) => ({
        ingredientGroups: s.ingredientGroups(state),
        modes: s.modes(state),
        texts: s.texts(state),
        totalPrice: s.totalPrice(state),
        formatMoney: price => formatMoney(s.currencyCode(state), s.localeCode(state), price)
    }),
    (dispatch) => ({
        selectMode: mode => dispatch(a.selectMode(mode)),
        finish: () => dispatch(a.finish())
    })
)(ConfiguratorPanel);
